import { gql } from '@apollo/client'

export const REQUEST_PACKAGES = gql`
  query REQUEST_PACKAGES {
    packages {
      packageId
      name
      description
      stepType
      packageType
      providerPackageId
    }
  }
`

export const ADD_PACKAGE = gql`
  mutation ADD_PACKAGE($input: AddPackageInput!) {
    addPackage(input: $input) {
      packageId
      name
      packageType
      providerPackageId
      stepType
    }
  }
`

export const UPDATE_PACKAGE = gql`
  mutation UPDATE_PACKAGE($packageId: String!, $input: UpdatePackageInput!) {
    updatePackage(packageId: $packageId, input: $input) {
      packageId
      name
      packageType
      providerPackageId
      stepType
    }
  }
`

export const DELETE_PACKAGE = gql`
  mutation DELETE_PACKAGE($packageId: String!) {
    deletePackage(packageId: $packageId) {
      packageId
      name
    }
  }
`

export const REFRESH_PACKAGES = gql`
  mutation REFRESH_PACKAGES {
    refreshPackages {
      packageId
      name
      packageType
      providerPackageId
      stepType
    }
  }
`
